<template>
  <div class="order-page">
    <el-card class="box-card">
      <el-form :model="form"
               style="width: 100%"
               label-width="90px"
               size="small">
        <el-row>
          <el-col :span="6">
            <el-form-item prop="tid"
                          label="订单号">
              <el-input v-model="form.tid"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="sku"
                          label="SKU">
              <el-input v-model="form.sku"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="from"
                          label="来源平台">
              <el-select clearable
                         v-model="form.from"
                         placeholder="请选择"
                         style="width: 90%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 90%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 90%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 90%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="payment"
                          label="订单实付金额"
                          label-width="110px">
              <el-input v-model="form.payment"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="post_fee"
                          label="运费">
              <el-input v-model="form.post_fee"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item prop="tax"
                          label="税费">
              <el-input v-model="form.tax"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item prop="original_status"
                          label="原始订单状态"
                          label-width="110px">
              <el-select clearable
                         v-model="form.original_status"
                         placeholder="请选择"
                         style="width: 90%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="status"
                          label="订单状态">
              <el-select clearable
                         v-model="form.status"
                         placeholder="请选择"
                         style="width: 90%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop
                          label="分阶段付款状态"
                          label-width="110px">
              <!-- // 字段还未定义 -->
              <el-input></el-input>
            </el-form-item>
          </el-col>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="created"
                            label="下单时间">
                <el-date-picker v-model="form.created"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="pay_time"
                            label="付款时间">
                <el-date-picker v-model="form.pay_time"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="consign_time"
                            label="发货时间">
                <el-date-picker v-model="form.consign_time"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="end_time"
                            label="交易完成时间"
                            label-width="120px">
                <el-date-picker v-model="form.end_time"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-col :span="6">
            <el-form-item prop="type"
                          label="订单类型">
              <el-select clearable
                         v-model="form.type"
                         placeholder="请选择"
                         style="width: 90%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="买家昵称">
              <el-input v-model="form.buyer_nick"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="buyer_memo"
                          label="买家留言">
              <el-input v-model="form.buyer_memo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="receiver_name"
                          label="收货人姓名">
              <el-input v-model="form.receiver_name"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item prop="receiver_country"
                          label="省">
              <el-select @change="provinceChange"
                         v-loading="provinceListLoading"
                         v-model="form.receiver_country"
                         placeholder="省"
                         clearable
                         style="width: 90%">
                <el-option v-for="item in provinceList"
                           :key="item.area_id"
                           :label="item.area_name"
                           :value="item.area_id">{{ item.area_name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="receiver_city"
                          label="市">
              <el-select @change="cityChange"
                         v-loading="cityListLoading"
                         v-model="form.receiver_city"
                         placeholder="市"
                         clearable
                         style="width: 90%">
                <el-option v-for="item in cityList"
                           :key="item.area_id"
                           :label="item.area_name"
                           :value="item.area_id">{{ item.area_name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="receiver_district"
                          label="区/县">
              <el-select v-loading="districtListLoading"
                         v-model="form.receiver_district"
                         placeholder="区/县"
                         style="width: 90%"
                         clearable>
                <el-option v-for="item in districtList"
                           :key="item.area_id"
                           :label="item.area_name"
                           :value="item.area_id">{{ item.area_name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="receiver_address"
                          label="地址">
              <el-input v-model="form.receiver_address"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item prop="receiver_mobile"
                          label="手机号">
              <el-input v-model="form.receiver_mobile"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="original_oid"
                          label="子订单号">
              <el-input v-model="form.original_oid"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="title"
                          label="商品名">
              <el-input v-model="form.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <el-row>
        <el-col :span="12">
          <el-button @click="handleExport"
                     type="primary"
                     size="medium">导出</el-button>
          <el-button @click="handleSearch"
                     size="medium">搜索</el-button>
          <el-button @click="clearSearch"
                     size="medium">重置</el-button>
          <!-- <el-button @click="handleImport" size="medium">导入</el-button> -->
          <div class
               style="display: inline-block;">
            <el-upload class="upload-demo"
                       action="fake"
                       :auto-upload="false"
                       :on-change="handleChange">
              <el-button size="small"
                         type="primary">点击上传</el-button>
              <div slot="tip"
                   class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
          </div>
          <el-button @click="handleExcelFile"
                     size="medium">处理ExcelFile</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              :data="tableData">
      <el-table-column align="center"
                       header-align="center"
                       prop="tid"
                       label="订单号"
                       width="180px"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="sku"
                       label="SKU"
                       width="180px"></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
  </div>
</template>

<script>
import XLSX from 'xlsx'
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { resolvingXLSX, dealReturn } from '@/common/js/index.js'
import { province, city, district } from '@/common/mixins/area-select'
export default {
  mixins: [ActionLine, SearchMixin, province, city, district],
  data() {
    return {
      form: {},
      platlists: [],
      loading: false,
      tableData: [],
      fileList: [],
      provinceList: [],
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    handleExport() {},
    async getTableData() {
      // this.loading = true;
      // let { data, err } = await axiosApi(platorders_api, this.queryPrdlists);
      // // console.log("data", data);
      // this.loading = false;
      // this.tableData = data.data.data.data;
      // this.total = parseInt(data.data.data.total);
      // dealReturn(data, err);
    },

    handleChange(file, fileList) {
      this.fileList = fileList
      console.log('file', file, fileList)
    },
    async handleExcelFile() {
      // debugger;
      let file = this.fileList[0].raw

      let fields = [
        '字段中文名',
        '订单号',
        '来源平台',
        '行业',
        '商家',
        '店铺',
        '订单实付金额',
        '运费',
        '税费',
        '原始订单状态',
        '订单状态',
        '分阶段付款状态',
        '订单类型',
        '下单时间',
        '付款时间',
        '发货时间',
        '交易完成时间',
        '买家昵称',
        '买家留言',
        '收货人姓名',
        '省',
        '市',
        '区',
        '地址',
        '手机号',
        '子订单号',
        '商品名',
        'SKU',
        '平台的商品code或编码',
        '商品原价',
        '商品实付金额',
        '商品应付金额',
        '商品优惠金额',
        '商品购买数量',
        '订单退款状态',
      ]

      let sheetName = '订单'
      let list = await this.resolvingXLSX(file, fields, sheetName) // 因为resolvingXLSX内部有 异步函数
      console.log('last list', list)
    },
    async resolvingXLSX(file, fields, sheetName) {
      // debugger;
      let list = []
      let data = await this.FunctionReadFile(file)
      // debugger;
      const workbook = XLSX.read(data.target.result, { type: 'binary' })
      const sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName])
      if (sheetArray.length == 0) {
        return
      }
      // 0 6 7
      let arr = [
        {
          index: 0,
          prop: 'name',
        },
        {
          index: 6,
          prop: 'isSearch',
        },
        {
          index: 7,
          prop: 'isTable',
        },
      ]
      for (let item of arr) {
        let rowTable = {}
        // debugger;
        var index = item.index
        for (let field of fields) {
          rowTable[field] =
            sheetArray[index][field] !== undefined
              ? sheetArray[index][field]
              : ''
        }
        list.push(rowTable)
      }
      console.log('before reutrn list', list)

      let objectList = []
      let KeyValueObj = list['0']
      let isSearchObj = list['1']
      let isTableLObj = list['2']
      for (let item in KeyValueObj) {
        objectList.push({
          name: KeyValueObj[item],
          title: item,
          isSearch: isSearchObj[item],
          isTable: isTableLObj[item],
        })
      }
      console.log('before reutrn objectList', objectList)

      return objectList
    },

    FunctionReadFile(file) {
      let fileReader = new FileReader()
      // debugger;
      return new Promise(function (resolve, reject) {
        fileReader.onload = (e) => {
          if (e.type === 'load') {
            resolve(e)
          } else {
            reject(e)
          }
        }
        fileReader.readAsBinaryString(file)
      })
    },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/rfm/rfmPrdList/index copy.vue